exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[data-v-2fc33f3a]::-webkit-outer-spin-button,\ninput[data-v-2fc33f3a]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\ninput[type='number'][data-v-2fc33f3a] {\n  -moz-appearance: textfield;\n}\n", ""]);

// exports
